import * as Sentry from "@sentry/gatsby";

Sentry.init({
    dsn: "https://945c53692bf14a85a00bf540db9cdcb8@o68629.ingest.sentry.io/4505425550180352",
    ignoreErrors: [
        "ChunkLoadError",
    ],
    tracesSampleRate: 1.0,
});